<template>
    <div>
        <b-field label="Data Collection Period Criteria">
            <b-dropdown
                multiple
                aria-role="list"
                class="checkbox-dropdown-field-container"
                :disabled="isDisabled"
            >
                <button
                    class="button is-primary multi-select-button"
                    type="button"
                    slot="trigger"
                    slot-scope="{ active }"
                >
                    <span class="text-input">
                        {{
                            selectedCriteria.length > 0
                            ? (isAllCriteriaSelected ? 'All Criteria' : `Selected Criteria (${selectedCriteria.length})`)
                            : 'Select Criteria'
                        }}
                    </span>
                    <b-icon
                        class="dropdown-arrow-icon-down"
                        type="is-black"
                        :icon="active? 'chevron-up' : 'chevron-down'"
                        size="is-small"
                    ></b-icon>
                </button>
                <b-dropdown-item
                    value="All Criteria"
                    class="dropdown-checkbox all-item"
                    :custom="true"
                >
                    <div class="checkbox-container">
                        <div class="column is-1 input-container width-auto">
                            <input type="checkbox" value="true" @change="updateAllSelection(false)" v-model="isAllCriteriaSelected">
                        </div>
                        <div class="column label-container align-left">
                            <label class="break-next-line text-size-body width-full bold color-bold-text" @click="updateAllSelection(true)" :class="$style.applyMargin">
                              All Criteria
                            </label>
                        </div>
                    </div>
                </b-dropdown-item>
                <b-dropdown-item
                    :value="value.name"
                    aria-role="listitem"
                    v-for="(value, index) in projectCriteria"
                    :key="index"
                    :class="[$style.dropdownItem, 'dropdown-checkbox']"
                    :custom="true"
                >
                    <div class="checkbox-container">
                        <div class="column is-1 input-container width-auto">
                            <input type="checkbox" :value="value.id" @change="updateSelection(false, value.id)" v-model="selectedCriteria">
                        </div>
                        <div class="column label-container align-left" >
                            <label class="break-next-line text-size-body" @click="updateSelection(true, value.id)">
                                <span class="break-next-line text-size-body width-full margin-bottom5">{{value.title}}</span>
                            </label>
                        </div>
                    </div>
                </b-dropdown-item>
            </b-dropdown>
        </b-field>
    </div>
</template>

<script lang="ts">
import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
import { cloneDeep as _cloneDeep } from 'lodash';
import {ProjectCriteria} from '@/store/modules/projects/types/projects.types';

@Component({ components : {} })

export default class ProjectCriteriaFilter extends Vue {
    @Prop()
    public projectCriteria!: ProjectCriteria[];
    @Prop()
    public filteredCriterias!: number[];
    @Prop({default: false})
    public isDisabled!: boolean;
    public selectedCriteria: number[] = [];
    public isAllCriteriaSelected: boolean = true;
    public allCriteriaIds: number[] = [];

    public mounted() {
        if (this.filteredCriterias.length !== 0) {
            this.populateFilteredData();
        } else {
            this.populateData();
        }
    }

    public populateData() {
        this.projectCriteria.map((projectCriteria: any) => {
            this.selectedCriteria.push(projectCriteria.id);
        });
        this.allCriteriaIds = _cloneDeep(this.selectedCriteria);
    }

    public populateFilteredData() {
        this.projectCriteria.map((projectCriteria: any) => {
            this.allCriteriaIds.push(projectCriteria.id);
        });
        this.selectedCriteria = _cloneDeep(this.filteredCriterias);
        if (this.allCriteriaIds.length !== this.selectedCriteria.length) {
            this.isAllCriteriaSelected = false;
        }
    }

    public updateSelection(label: boolean = false, id: number) {
        if (label) {
            const criteriaIndex = this.selectedCriteria.indexOf(id);
            if (criteriaIndex === -1) {
                this.selectedCriteria.push(id);
            } else {
                this.selectedCriteria.splice(criteriaIndex, 1);
            }
        }
        this.isAllCriteriaSelected = this.allCriteriaIds.length === this.selectedCriteria.length;
        this.emitCriteriaFilter();
    }

    public updateAllSelection(label: boolean = false) {
        if (label) {
            this.isAllCriteriaSelected = !this.isAllCriteriaSelected;
        }
        if (this.isAllCriteriaSelected) {
            this.selectedCriteria = _cloneDeep(this.allCriteriaIds);
        } else {
            this.selectedCriteria = [];
        }
        this.emitCriteriaFilter();
    }

    public mapOrder(selectedCriteria: number[], projectCriteriaMapIds: number[]) {
        selectedCriteria.sort((selectedSite, selectedSiteNext) => {
            if (projectCriteriaMapIds.indexOf(selectedSite) > projectCriteriaMapIds.indexOf(selectedSiteNext)) {
                return 1;
            } else {
                return -1;
            }
        });
        return selectedCriteria;
    }

    public emitCriteriaFilter() {
        if (!(this.selectedCriteria.length === 0 || this.selectedCriteria.length === 1)) {
            const projectCriteriaMapIds: number[] = this.projectCriteria.map((projectCriteria) => projectCriteria.id);
            this.selectedCriteria = this.mapOrder(this.selectedCriteria, projectCriteriaMapIds);
        }
        this.$emit('applyCriteriaFilter', this.selectedCriteria);
    }
}
</script>
<style lang="scss" module>
    .applyMargin {
        margin-left: -2px;
    }
    .dropdownItem {
        border-bottom: 0.5px solid #DBDBDB;
    }
    .dropdownItem:last-child {
        border-bottom: unset;
    }
</style>
